module.exports = __webpack_public_path__ + "static/media/bihar.85e2304b.png";